module.exports = __webpack_public_path__ + "assets/img/travel-save.86ce27c9.png";